window.addEventListener('DOMContentLoaded', () => {
  const backTop = document.querySelector('.backTopPage');
  const progressCircle = backTop?.querySelector('.progress');

  if (backTop) {
    backTop.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const { scrollHeight } = document.documentElement;
      const clientHeight = window.innerHeight;

      const maxOffset = 307.919;

      const scrollPercentage = Math.min(
        100,
        Math.max(0, (scrollTop / (scrollHeight - clientHeight)) * 100),
      );

      if (scrollTop > 50) {
        backTop.classList.add('show');

        const offset = maxOffset * ((100 - scrollPercentage) / 100);

        if (progressCircle) {
          progressCircle.style.strokeDashoffset = offset;
        }
      } else {
        backTop.classList.remove('show');
      }
    };

    window.addEventListener('scroll', updateProgress);

    updateProgress();
  }
});
